import React, { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';

import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import AccountCircle from '@mui/icons-material/AccountCircle';
import ExitIcon from '@mui/icons-material/ExitToApp';
import { useMediaQuery, Theme, MenuItem, ListItemIcon, IconProps } from '@mui/material';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

const useStyles = makeStyles(
  (theme: Theme) => createStyles({
    menuItem: {
      color: theme.palette.text.secondary,
    },
    icon: { minWidth: theme.spacing(5) },
  }),
  { name: 'RaLogout' }
);

const Logout = React.forwardRef<HTMLLIElement>(function Logout(props, ref) {
  const classes = useStyles(props);
  const isXSmall = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down('sm')
  );
  const [t] = useTranslation();

  return (
    <MenuItem
      className={classes.menuItem}
      onClick={props.logout}
      ref={ref}
      component={isXSmall ? 'span' : 'li'}
    >
      <ListItemIcon className={classes.icon}>
        <ExitIcon />
      </ListItemIcon>
      {t('auth.logout')}
    </MenuItem>
  );
});

const UserMenu: FunctionComponent<{icon?: IconProps, logout: () => void}> = (props) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [t] = useTranslation();

  const { icon } = props;
  const open = Boolean(anchorEl);

  const handleMenu = event => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(null);

  return (
    <div>
      <Tooltip title={t('auth.user_menu')}>
        <IconButton
          aria-label={t('auth.user_menu')}
          aria-owns={open ? 'menu-appbar' : null}
          aria-haspopup={true}
          color="inherit"
          onClick={handleMenu}
          size="large">
          {icon}
        </IconButton>
      </Tooltip>
      <Menu
        id="menu-appbar"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={open}
        onClose={handleClose}
      >
        <Logout logout={props.logout} />
      </Menu>
    </div>
  );
};


UserMenu.defaultProps = {
  icon: <AccountCircle />,
};

export default UserMenu;
